import { render, staticRenderFns } from "./CreateArticle.vue?vue&type=template&id=4f1491a3&scoped=true&"
import script from "./CreateArticle.vue?vue&type=script&lang=js&"
export * from "./CreateArticle.vue?vue&type=script&lang=js&"
import style0 from "./CreateArticle.vue?vue&type=style&index=0&id=4f1491a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1491a3",
  null
  
)

export default component.exports